/**
 * Export service for CSV downloads (Available to all users including Free plan)
 */

import { getBackendBaseUrl } from '../utils/configUtils';

class ExportService {
  constructor() {
    this.baseURL = getBackendBaseUrl();
  }

  /**
   * Get authentication headers
   */
  getAuthHeaders() {
    const token = localStorage.getItem('cubxly_token');
    return {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
  }

  /**
   * Export all items as CSV
   */
  async exportItems() {
    try {
      const response = await fetch(`${this.baseURL}/api/v2/export/items`, {
        method: 'GET',
        headers: this.getAuthHeaders()
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to export items');
      }

      // Get the CSV content
      const csvContent = await response.text();
      
      // Create download link
      const blob = new Blob([csvContent], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'my_items.csv';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return { success: true, message: 'Items exported successfully' };
    } catch (error) {
      console.error('Export items error:', error);
      return { success: false, error: error.message };
    }
  }

  /**
   * Export all boxes as CSV
   */
  async exportBoxes() {
    try {
      const response = await fetch(`${this.baseURL}/api/v2/export/boxes`, {
        method: 'GET',
        headers: this.getAuthHeaders()
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to export boxes');
      }

      // Get the CSV content
      const csvContent = await response.text();
      
      // Create download link
      const blob = new Blob([csvContent], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'my_boxes.csv';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return { success: true, message: 'Boxes exported successfully' };
    } catch (error) {
      console.error('Export boxes error:', error);
      return { success: false, error: error.message };
    }
  }
}

// Create and export a singleton instance
const exportService = new ExportService();
export default exportService;
